module.exports = __webpack_public_path__ + "static/SuperHealthPharmacyperson-e7129a0b72c2d4822025db72d957bd0f.jpg";